//const ReservedContextKeys = [] as const;
/**
 * @todo Example reserved keys
 */
const ReservedContextKeys = ['caseId', 'caseNumber'];
const ReservedContextKeysToControllerMap = {
    caseId: 'caseContext',
    caseNumber: 'caseContext',
};
export class ReservedContextKeyError extends Error {
    constructor(key) {
        super(`The key "${key}" is reserved for internal use. Use ${ReservedContextKeysToControllerMap[key]} to set this value.}`);
    }
}
export class UnreservedContextKeyError extends Error {
    constructor(key) {
        super(`The key "${key}" has not been reserved. Please report this error to Coveo on https://github.com/coveo/ui-kit/issues/new.`);
    }
}
export function isReservedContextKey(contextKey) {
    return ReservedContextKeys.includes(contextKey);
}
